import { TEXTOS } from '../../../lib/glossario'
import type { IndicadorNaTela } from '../../../types/chamado'
import { valorPorExtenso } from './indicadores'

/**
 * As duas leituras do TR quando elas discordam sobre o desconto.
 *
 * **Aparece só na borda.** Longe dela, as duas leituras dão no mesmo e mostrá-las seria ruído; na
 * borda, o número apurado sozinho não explica o desconto, e quem assina o termo de recebimento
 * precisa saber que houve uma escolha de arredondamento — e qual foi.
 *
 * **Não muda nada.** O desconto aplicado continua sendo o do indicador, decidido pelo domínio. Este
 * bloco é leitura: ele mostra o que teria acontecido pela outra leitura admitida no contrato.
 *
 * @param props o indicador apurado
 * @returns o aviso das duas leituras, ou nada quando elas concordam
 */
export function LeiturasDoEnquadramento({ indicador }: { indicador: IndicadorNaTela }) {
  if (!indicador.enquadramentoNaBorda || indicador.leituras.length < 2) {
    return null
  }
  const t = TEXTOS.enquadramento

  return (
    <div className="mt-4 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-slate-800">
      <p className="font-semibold text-amber-900">{t.tituloDaBorda}</p>
      <ul className="mt-1.5 space-y-0.5">
        {indicador.leituras.map((leitura, posicao) => (
          <li key={leitura.comoSeLe} className="tabular-nums">
            {leitura.comoSeLe === 'arredondado' ? t.arredondado : t.truncado}:{' '}
            <strong className="font-semibold">{valorPorExtenso(indicador.codigo, leitura.valor)}</strong> →{' '}
            {leitura.redutorPercentual === 0 ? t.semDesconto : `${leitura.redutorPercentual}% de desconto`}
            {/* A primeira é sempre a aplicada — o domínio devolve nessa ordem. */}
            {posicao === 0 && <span className="ml-1 font-medium text-amber-900">({t.aplicada})</span>}
          </li>
        ))}
      </ul>
      <p className="mt-1.5 max-w-prose">{t.ajudaDaBorda}</p>
      {indicador.codigo === 'IAP' && <p className="mt-1.5 max-w-prose">{t.ressalvaDoIap}</p>}
    </div>
  )
}
